module.exports = __webpack_public_path__ + "media/AUDIO 08.15ccdbc5.mp3";